export type AuditCategory = 'change' | 'access' | 'authentication';

export interface AuditLogEntryApiResource {
  id: string;
  action: string;
  category: AuditCategory;
  actor_user_id: string | null;
  actor_name: string | null;
  actor_email: string | null;
  tenant_id: string | null;
  tenant_name: string | null;
  target_type: string | null;
  target_id: string | null;
  subject_client_id: string | null;
  client_name: string | null;
  subject_patient_id: string | null;
  patient_name: string | null;
  summary: string | null;
  ip_address: string | null;
  device_browser: string | null;
  device_operating_system: string | null;
  is_elevated_access: boolean;
  created_at: string;
}

export interface AuditLogEntry {
  id: string;
  action: string;
  category: AuditCategory;
  actorUserId: string | null;
  actorName: string | null;
  actorEmail: string | null;
  tenantId: string | null;
  tenantName: string | null;
  targetType: string | null;
  targetId: string | null;
  subjectClientId: string | null;
  clientName: string | null;
  subjectPatientId: string | null;
  patientName: string | null;
  summary: string | null;
  ipAddress: string | null;
  deviceBrowser: string | null;
  deviceOperatingSystem: string | null;
  isElevatedAccess: boolean;
  createdAt: string;
}

export interface AuditLogQuery {
  page: number;
  pageSize: number;
  search: string;
  category: AuditCategory | null;
  clientId: string | null;
  occurredFrom: string | null;
  occurredUntil: string | null;
}

export function mapApiResourceToAuditLogEntry(resource: AuditLogEntryApiResource): AuditLogEntry {
  return {
    id: resource.id,
    action: resource.action,
    category: resource.category,
    actorUserId: resource.actor_user_id,
    actorName: resource.actor_name,
    actorEmail: resource.actor_email,
    tenantId: resource.tenant_id,
    tenantName: resource.tenant_name,
    targetType: resource.target_type,
    targetId: resource.target_id,
    subjectClientId: resource.subject_client_id,
    clientName: resource.client_name,
    subjectPatientId: resource.subject_patient_id,
    patientName: resource.patient_name,
    summary: resource.summary,
    ipAddress: resource.ip_address,
    deviceBrowser: resource.device_browser,
    deviceOperatingSystem: resource.device_operating_system,
    isElevatedAccess: resource.is_elevated_access,
    createdAt: resource.created_at,
  };
}
